import { graphql } from '@mp/graphql/generated';
import { type ResultOf } from '@graphql-typed-document-node/core';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';

const AvailableProfessionalsForJobGql = graphql(`
  query GetAvailableProfessionalsForJob {
    availableProfessionalsForJob {
      id
      name
      account_id
    }
  }
`);

type AvailableProfessionalsForJobProps = ResultOf<typeof AvailableProfessionalsForJobGql>;

export const useSwapProfessionalsList = ({ jobId }: { jobId?: number | null }) => {
  const { data, isLoading } = useGraphQLQuery<AvailableProfessionalsForJobProps>({
    operationName: 'GetAvailableProfessionalsForJob',
    query: AvailableProfessionalsForJobGql,
    enabled: !!jobId,
    variables: {
      input: {
        search: {
          available_for_job_id: Number(jobId),
        },
      },
    },
  });
  const availableProfessionals = data?.availableProfessionalsForJob ?? [];

  return { availableProfessionals, isLoading };
};
